export namespace ZoneEnforcedCheckinResponsive {
    export const level1 = 600;
    export const level2 = 575;
    export const level3 = 500;
    export const level4 = 700;
}
